// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'
import _keyBy from 'lodash/keyBy'
import _indexOf from 'lodash/indexOf'

// Selectors
import selectedFarmId$ from './selectedFarmId'
import { selectedSeasonId$ } from 'hfty-seasons'
import fields$ from 'fc-assets/src/selectors/fields'
import ancestorsIndex$ from 'fc-assets/src/selectors/ancestorsIndex'

// Constants
import { PROP_ASSET_ID, PROP_SEASON } from 'fc-model-assets'

// Utils
import emptyObjectOr from 'fc-utils/emptyObjectOr'

// Exports
export default createSelector(
  [
    selectedFarmId$,
    selectedSeasonId$,
    fields$,
    ancestorsIndex$,
  ],
  (farmId, seasonId, fields, ancestors) => {
    const fieldsInSeasonOfFarm = _filter(fields, (field) => {
      return (_indexOf(ancestors[field[PROP_ASSET_ID]], farmId) > -1) &&
        (field[PROP_SEASON] === seasonId)
    })

    return emptyObjectOr(_keyBy(fieldsInSeasonOfFarm, PROP_ASSET_ID))
  })
